import React from "react";
import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import BTNLoader from "./BTNLoader";

const AppSelectField = ({
  value,
  onChange = (e) => null,
  items = [],
  placeholder,
  label,
  helperText = undefined,
  error = false,
  isLoading = false,
  ...props
}) => {
  const labelId = label ? `app-select-${String(label).toLowerCase().replace(/\s+/g, "-")}` : undefined;

  return (
    <FormControl error={error} fullWidth size="small">
      {label ? (
        <InputLabel id={labelId} shrink>
          {label}
        </InputLabel>
      ) : null}
      <Select
        startAdornment={
          <InputAdornment position="start">
            <BTNLoader isLoading={isLoading} />
          </InputAdornment>
        }
        fullWidth
        size="small"
        displayEmpty
        label={label || undefined}
        labelId={labelId}
        notched={label ? true : undefined}
        value={value}
        onChange={onChange}
        inputProps={{ className: "bg-white" }}
        {...props}
      >
        {placeholder ? (
          <MenuItem disabled value="">
            {placeholder}
          </MenuItem>
        ) : null}
        {items?.map((item, index) => (
          <MenuItem value={item?.value} key={index}>
            {item?.label}
          </MenuItem>
        ))}
      </Select>

      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default AppSelectField;

export const AppMultiSelect = ({ error, helperText, isOptionChecked, ...props }) => {
  const itemsMap = {};
  for (const item of props.items) {
    itemsMap[item.value] = item.label;
  }
  return (
    <FormControl error={!!error} sx={{ width: "100%" }}>
      <Select
        multiple
        size="small"
        input={<OutlinedInput />}
        renderValue={(selected) => selected.map((value) => itemsMap[value] ?? value).join(", ")}
        variant="outlined"
        displayEmpty
        sx={{ width: "100%", ...props.sx }}
        {...props}
      >
        {props.items.map((item) => {
          const checked = isOptionChecked
            ? isOptionChecked(item, props.value ?? [])
            : (props.value ?? []).indexOf(item.value) > -1;

          return (
            <MenuItem key={item.value} value={item.value}>
              <Checkbox size="small" checked={checked} />
              <ListItemText primary={item?.label} />
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
